<template>
  <NavBar class="ExportNavBar">
    <!-- This may be not 100% accurate, due to feature restrictions.
         To avoid complexity the dropdown is then simply shown with 1 item. -->
    <MunicipalitySelection
      v-if="canAccessMultipleMunicipalities"
      filter="export"
      class="mr-3"
    />

    <router-link
      v-if="superuser"
      class="d-inline-flex align-center mr-3"
      :to="{ name: 'Dashboard', params: { municipality: activeMunicipalitySlug } }"
    >
      <i class="far fa-fw fa-gear icon" />
    </router-link>
  </NavBar>
</template>

<script>
import NavBar from '@/components/common/NavBar'
import MunicipalitySelection from '@/components/navbar/MunicipalitySelection'

import { codeToSlug } from '@/services/municipalities'

import { mapGetters } from 'vuex'

export default {
  name: 'ExportNavBar',
  components: {
    NavBar, MunicipalitySelection,
  },
  computed: {
    ...mapGetters('config', [
      'hasLayers',
    ]),
    ...mapGetters('access', [
      'getActiveMunicipality',
      'hasAdminAccess',
      'canAccessMultipleMunicipalities',
    ]),
    superuser() {
      return this.$auth.user && this.$auth.user['https://evmaps.nl/superuser']
    },
    admin() {
      return this.hasAdminAccess({ code: this.getActiveMunicipality })
    },
    activeMunicipalitySlug() {
      return codeToSlug({ code: this.getActiveMunicipality })
    },
    canPreAccessPrognose() {
      return this.hasLayers({ code: this.getActiveMunicipality }) && ( this.superuser || this.admin )
    },
  },
}
</script>

<style lang="scss">
.ExportNavBar {
  .icon {
    color: white;
    font-size: 1.75rem;
    cursor: pointer;
  }
}
.ExportNavBar__Logout {
  color: white;
  cursor: pointer;

  &:hover {
    color: var(--cta);
  }
}
</style>
